import { Button, CircularProgress } from "@mui/material";
import React from "react";
import { BookingOverviewContext } from "../context/bookingOverviewContext";
import { SearchCriteria } from "../interface/bookingOverviewInterface";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";

const StartSearchButton = (): React.JSX.Element => {
  const {
    searchCriteria,
  }: {
    searchCriteria: SearchCriteria;
  } = React.useContext(BookingOverviewContext);

  const handleDisable = (): boolean =>
    searchCriteria.loading ||
    (searchCriteria.partipantName === "" &&
      searchCriteria.date === "" &&
      (searchCriteria.coach?.label === "Alle" ||
        searchCriteria.coach === null));

  const renderStartIcon = (): React.JSX.Element =>
    searchCriteria.loading ? (
      <CircularProgress
        size={18}
        sx={{
          color: "white",
        }}
      />
    ) : (
      <SearchOutlinedIcon />
    );

  const renderButtonText = (): string =>
    searchCriteria.loading ? "Lädt..." : "Suchen";

  return (
    <Button
      disabled={handleDisable()}
      startIcon={renderStartIcon()}
      type="submit"
      fullWidth
      size="large"
      sx={{
        height: "100%",
      }}
      variant="contained"
      color="primary"
    >
      {renderButtonText()}
    </Button>
  );
};

export default StartSearchButton;
